// 创建一个pendding状态的Promise
// 在sendPV之后调用resolvePv()使该promise 状态改变
// 后续的埋点上报都通过afterPv.then来进行
let resolvePv;
const afterPv = new Promise((resolve) => {
    resolvePv = resolve;
});
export { afterPv, resolvePv };
